"use strict";

exports.__esModule = true;
exports.AuditLogGrid = AuditLogGrid;
var _react = _interopRequireDefault(require("react"));
var _vimanaTypes = require("@vimana/vimana-types");
var _Report = require("../../Report");
var _AuditLogGridConfig = require("./AuditLogGridConfig");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function AuditLogGrid(props) {
  var width = props.width,
    height = props.height,
    style = props.style;
  return /*#__PURE__*/_react["default"].createElement(_Report.StandardReportDataProvider, null, /*#__PURE__*/_react["default"].createElement(_Report.Report, {
    config: _AuditLogGridConfig.config,
    width: width,
    height: height,
    style: style
  }));
}